<div class="reset-participant-videos-part">
	<h4>Reset Participant Videos</h4>

	<div class="participants-container">
		@for (participant of allParticipants(); track participant.personId) {
		<div class="participant-card">
			<div class="card-body">
				<h6 class="card-title mb-3">
					{{ participant.displayName }}
				</h6>

				<div class="card-actions">
					@if (participant.uniqueVideoId) {
					<common-button-row>
						<button type="button" class="btn btn-sm btn-outline-primary"
							(click)="openVideoDialog(participant.personId, participant.uniqueVideoId)"
							title="View Video">
							<i class="fa-regular fa-circle-play me-1"></i>
							View
						</button>
						<button type="button" class="btn btn-sm btn-outline-warning"
							[disabled]="isResetting() || !canManageApplication()"
							(click)="resetVideo(participant.accApplicationParticipantId, participant.personId, participant.uniqueVideoId)"
							title="Reset Video">
							@if (isResetting()) {
							<i class="fa-regular fa-spinner fa-spin me-1"></i>
							Resetting...
							} @else {
							<i class="fa-regular fa-rotate-left me-1"></i>
							Reset
							}
						</button>
						<button type="button" class="btn btn-sm btn-outline-danger"
							[disabled]="isDeleting() || !canManageApplication()"
							(click)="deleteVideo(participant.accApplicationParticipantId, participant.personId, participant.uniqueVideoId)"
							title="Delete Video">
							@if (isDeleting()) {
							<i class="fa-regular fa-spinner fa-spin me-1"></i>
							Deleting...
							} @else {
							<i class="fa-regular fa-trash me-1"></i>
							Delete
							}
						</button>
					</common-button-row>
					} @else {
					<common-button-row>
						<button type="button" class="btn btn-sm btn-outline-secondary" disabled
							title="No video uploaded">
							<i class="fa-regular fa-circle-xmark me-1"></i>
							No Video
						</button>
					</common-button-row>
					}
				</div>
			</div>
		</div>
		}
		@empty {
		<div class="text-center text-muted py-3">
			No participants found
		</div>
		}
	</div>
</div>